/* eslint-disable */
// @ts-nocheck
module.exports = (function () {
    if (typeof globalThis === 'object') {
        return globalThis;
    }

    let result;

    try {
        // This works if eval is allowed (see CSP)
        result = this || new Function('return this')();
    } catch (e) {
        // This works if the window reference is available
        if (typeof window === 'object') {
            return window;
        }

        // This works if the self reference is available
        if (typeof self === 'object') {
            return self;
        }

        // This works if the global reference is available
        if (typeof global !== 'undefined') {
            return global;
        }
    }

    return result;
})();
